import React from 'react';
import CIcon from '@coreui/icons-react';
import {
  cilNotes,
  cilSpeedometer,
  cilUser,
  cilFolderOpen,
  cilHeadphones,
  cilColorBorder,
  cilWarning,
  cilCart,
  cilGrid,
  cilCog,
  cilFlightTakeoff,
  cilAirplaneMode,
  cilMoney,
  cilHome,
  cilBook,
  cilGroup,
  cilCalendar,
  cilCheck,
  cilClipboard,
} from '@coreui/icons';
import { CNavGroup, CNavItem, CNavTitle } from '@coreui/react';


const _nav = [
  {
    component: CNavItem,
    name: 'Dashboard',
    to: '/dashboard',
    icon: <CIcon icon={cilHome} customClassName="nav-icon" />,
    perm: 'dashboard',

  },

  {
    component: CNavTitle,
    className: 'flex align-right',
    name: 'ORGANIZATION',
    perm: 'dashboard',
  },
  //Employee Portal
  {
    component: CNavGroup,
    name: 'Employee Portal',
    icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'My Time Sheet',
        to: '/employeeportal/TimeSheet',
        perm: 'dashboard',
      },

      {
        component: CNavItem,
        name: 'My Roster',
        to: '/employeeportal/myRoster',
        perm: 'dashboard',
      },

      {
        component: CNavItem,
        name: 'My Task(s)',
        /* to: '/employeeportal/myTask',*/
        to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
        target: '_blank',
        perm: 'dashboard',
      },
      {
        component: CNavItem,
        name: 'My Message(s)',
        to: '/employeeportal/MyMessages',
        perm: 'dashboard',
      },
      {
        component: CNavItem,
        name: 'My Flight Time',
        to: '/employeeportal/myFlightTime',
        perm: 'crew',
      },

      {
        component: CNavItem,
        name: 'Apply For Leave',
        to: '/employeeportal/applyForleave',
        perm: 'dashboard',
      },

      {
        component: CNavItem,
        name: 'My Leave Status',
        to: '/employeeportal/myLeavestatus',
        perm: 'dashboard',
      },

      {
        component: CNavItem,
        name: 'Document(s) Alert(s)',
        to: '/employeeportal/documentsAlerts',
        perm: 'dashboard',
      },

      {
        component: CNavItem,
        name: 'Contacts',
        to: '/employeeportal/contacts',
        perm: 'dashboard',
      },
      {
        component: CNavItem,
        name: 'Generate Document Number',
        to: '/employeeportal/RefNo',
        perm: 'dashboard',
      },

      {
        component: CNavItem,
        name: 'My Pay Slip',
        to: '/employeeportal/myPayslip',
        perm: 'dashboard',
      },

      {
        component: CNavItem,
        name: 'My Tax Certificate',
        to: '/employeeportal/myTaxcertificate',
        perm: 'dashboard',
      },

      {
        component: CNavItem,
        name: 'Company Property',
        to: '/employeeportal/companyProperty',
        perm: 'dashboard',
      },
      {
        component: CNavItem,
        name: 'Leave Recommendation',
        to: '/employeeportal/leaveRecommendation',
        perm: 'mgr',
      },
      {
        component: CNavItem,
        name: 'My Subordinate(s)',
        to: '/employeeportal/mySubordinates',
        perm: 'mgr',
      },

      {
        component: CNavItem,
        name: 'My Events',
        to: '/employeeportal/myEvents',
        perm: 'dashboard',
      },


    ],
  },
  //Document Library
  {
    component: CNavGroup,
    name: 'Document Library',
    icon: <CIcon icon={cilBook} customClassName="nav-icon" />,
    items: [
      {
        component: CNavGroup,
        name: 'Flight Operations',
        perm: 'fltlib',
        items: [
          {
            component: CNavItem,
            name: 'FOM Part A',
            to: '/publications/fltopsmanuals/fom-part-a',
            perm: 'fltlib',


          },
          {
            component: CNavItem,
            name: 'FOM Part B',
            to: '/publications/fltopsmanuals/fom-part-b',
            perm: 'fltlib',


          },
          {
            component: CNavItem,
            name: 'FOM Part C',
            to: '/publications/fltopsmanuals/fom-part-c',
            perm: 'fltlib',

          },
          {
            component: CNavItem,
            name: 'FOM Part D',
            to: '/publications/fltopsmanuals/fom-part-d',
            perm: 'fltlib',
          },
          {
            component: CNavItem,
            name: 'Dispatch Manual',
            to: '/publications/fltopsmanuals/dispatch-manual',
            perm: 'fltlib',

          },
          {
            component: CNavItem,
            name: 'MEL B733',
            to: '/publications/fltopsmanuals/b733-mel',
            perm: 'fltlib',
          },
          {
            component: CNavItem,
            name: 'DDG B733',
            to: '/publications/fltopsmanuals/b733-ddg',
            perm: 'fltlib',

          },
          {
            component: CNavItem,
            name: 'SOP B733',
            to: '/publications/fltopsmanuals/b733-sop',
            perm: 'fltlib',

          },
          {
            component: CNavItem,
            name: 'FCOM B733',
            to: '/publications/fltopsmanuals/b733-fcom',
            perm: 'fltlib',
          },
          {
            component: CNavItem,
            name: 'QRH B733',
            to: '/publications/fltopsmanuals/b733-qrh',
            perm: 'fltlib',

          },
          {
            component: CNavItem,
            name: 'FCTM B733',
            to: '/publications/fltopsmanuals/b733-fctm',
            perm: 'fltlib',

          },
          {
            component: CNavItem,
            name: 'Flight Data Monitoring',
            to: '/publications/fltopsmanuals/fdm',
            perm: 'fltlib',

          },
          {
            component: CNavItem,
            name: 'Mass & Balance Program ',
            to: '/publications/fltopsmanuals/massnbalance',
            perm: 'fltlib',
          },
        ],
      },
      {
        component: CNavGroup,
        name: 'CAMO & MRO',
        perm: 'mntlib',
        items: [

          {
            component: CNavItem,
            name: 'MOE',
            to: '/publications/enggmaintmanuals/moe',
            perm: 'mntlib',

          },
          {
            component: CNavItem,
            name: 'MCM',
            to: '/publications/enggmaintmanuals/mcm',
            perm: 'mntlib',

          },
        ],
      },
      {
        component: CNavGroup,
        name: 'Company',
        perm: 'orglib',
        items: [
          {
            component: CNavItem,
            name: 'Ground Operations Manual',
            to: '/publications/companymanuals/gom',
            perm: 'orglib',

          },
          {
            component: CNavItem,
            name: 'Security Manual',
            to: '/publications/companymanuals/sec',
            perm: 'orglib',

          },
          {
            component: CNavItem,
            name: 'SMS Manual',
            to: '/publications/companymanuals/sms',
            perm: 'orglib',

          },
          {
            component: CNavItem,
            name: 'Quality Manual',
            to: '/publications/companymanuals/qam',
            perm: 'orglib',

          },
          {
            component: CNavItem,
            name: 'ERM',
            to: '/publications/companymanuals/erm',
            perm: 'orglib',

          },
          {
            component: CNavItem,
            name: 'Human Resource Manual',
            to: '/publications/companymanuals/hr',
            perm: 'orglib',

          },
          {
            component: CNavItem,
            name: 'Dangerous Goods Regulations',
            to: '/publications/companymanuals/dgr',
            perm: 'orglib',

          },


        ],
      },

      {
        component: CNavItem,
        name: 'Company Forms',
        to: '/publications/companyForms',
        perm: 'dashboard',
      },

      {
        component: CNavItem,
        name: 'Company Documents',
        //to: '/documentLibrary/companyDocuments',
        to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
        target: '_blank',
        perm: 'aucd',
      },

    ],
  },
  //HR
  {
    component: CNavGroup,
    name: 'Admin & HR',
    icon: <CIcon icon={cilGroup} customClassName="nav-icon" />,
    perm: 'dashboard',
    items: [
      {
        component: CNavGroup,
        name: 'Employee',
        items: [
          {
            component: CNavItem,
            name: 'Employement Form',
            /*to: '/hr/employee/employementForm',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'ce',
          },

        ],
      },
      {
        component: CNavItem,
        name: 'Employee Roster',
        to: '/hr/EmpRoster',
        perm: 'er',
      },
      {
        component: CNavItem,
        name: 'Attendance Management',
        /*to: '/hr/attendanceManagement',*/
        to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
        target: '_blank',
        perm: 'eam',
      },
      {
        component: CNavItem,
        name: 'Message Board',
        /*to: '/hr/messageBoard',*/
        to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
        target: '_blank',
        perm: 'mb',
      },

      {
        component: CNavItem,
        name: 'Leave Management',
        /*to: '/hr/leaveManagement',*/
        to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
        target: '_blank',
        perm: 'hrmgr',
      },
      {
        component: CNavGroup,
        name: 'Reports',
        items: [
          {
            component: CNavItem,
            name: 'Employee List',
            to: '/hr/reports/employeeList',
            perm: 'le',
          },
          {
            component: CNavItem,
            name: 'Upcoming Birthday',
            /*to: '/hr/reports/upcomingBirthday',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'ubl',
          },
          {
            component: CNavItem,
            name: "Today's Attendance",
            /*to: '/hr/reports/todaysAttendance',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'ta',
          },
          {
            component: CNavItem,
            name: 'Monthly Attendance',
            /*to: '/hr/reports/monthlyAttendance',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'ma',
          },
          {
            component: CNavItem,
            name: 'Search Company Property',
            /*to: '/hr/reports/searchCompanyProperty',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'scpr',
          },
        ],
      },
      {
        component: CNavGroup,
        name: 'Manage Forms',
        items: [
          {
            component: CNavItem,
            name: 'Add/Update Form(s)',
            /*to: '/hr/manageForms/addUpdateForms',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'fauir',
          },
          {
            component: CNavItem,
            name: 'Issue Form(s)',
            /*to: '/hr/manageForms/issueForms',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'fauir',
          },
          {
            component: CNavItem,
            name: 'Receive Form(s)',
            /*to: '/hr/manageForms/receiveForms',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'fauir',
          },
          {
            component: CNavItem,
            name: 'Forms Report',
            /*to: '/hr/manageForms/formsReport',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'frl',
          },
          {
            component: CNavItem,
            name: 'Forms List',
            /*to: '/hr/manageForms/formsList',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'frl',
          },

        ],
      },
    ],
  },
  //Payroll
  {
    component: CNavGroup,
    name: 'Payroll',
    icon: <CIcon icon={cilMoney} customClassName="nav-icon" />,
    items: [

      {
        component: CNavItem,
        name: 'Payroll Management',
        /*to: '/payroll/payrollManagement',*/
        to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
        target: '_blank',
        perm: 'finpr',
      },
    ],
  },
  {
    component: CNavTitle,
    name: 'FLIGHT OPERATIONS',
    perm: 'dashboard',
  },

  //Aircraft Charter
  {
    component: CNavGroup,
    name: 'Aircraft Charter',
    icon: <CIcon icon={cilAirplaneMode} customClassName="nav-icon" />,
    perm: 'ach',
    items: [
      {
        component: CNavItem,
        name: 'Flight Booking',
        /* to: '/aircraftCharter/flightBooking',*/
        to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
        target: '_blank',
        perm: 'bf',
      },
      {
        component: CNavItem,
        name: 'Quotation(s)',
        /*to: '/aircraftCharter/charterQuote',*/
        to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
        target: '_blank',
        perm: 'achq',
      },
      {
        component: CNavItem,
        name: 'Customer(s)',
        /*to: '/aircraftCharter/customers',*/
        to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
        target: '_blank',
        perm: 'achc',
      },

    ],
  },
  //Flight Opeations
  {
    component: CNavGroup,
    name: 'Flight Operations',
    icon: <CIcon icon={cilHeadphones} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Add Flight Log',
        /*to: '/flightOperations/addFlightlog',*/
        to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
        target: '_blank',
        perm: 'afl',
      },
      {
        component: CNavGroup,
        name: 'Status Board',
        items: [
          {
            component: CNavItem,
            name: 'Add/Update Flight',
            /* to: '/flightOperations/statusBoard/addUpdateFlight',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            perm: 'afl',
          },
          {
            component: CNavItem,
            name: 'Movements History',
            /*to: '/flightOperations/statusBoard/boardHistory',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'afl',
          },
        ],
      },
      {
        component: CNavGroup,
        name: 'Reports',
        items: [
          {
            component: CNavItem,
            name: 'Operations Report',
            /*to: '/flightOperations/reports/operationsReport',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'for',
          },
          {
            component: CNavItem,
            name: 'Find Flight Log',
            /*to: '/flightOperations/reports/findFlightLog',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'flr',
          },
          {
            component: CNavItem,
            name: 'Customized Flight Log',
            /*to: '/flightOperations/reports/flightLogReport',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'flr',
          },
          {
            component: CNavItem,
            name: 'Complete Flight Log',
            /*to: '/flightOperations/reports/completeFlightLog',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'flr',
          },
          {
            component: CNavItem,
            name: 'Crew List',
            to: '/flightOperations/reports/crewList',
            /*to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',*/
            perm: 'cddr',
          },
          {
            component: CNavItem,
            name: 'Crew Flight Time',
            /*to: '/flightOperations/reports/crewFDT',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'cfdt',
          },
        ],
      },

    ],
  },

  {
    component: CNavTitle,
    name: 'MAINTENANCE',
    perm: 'dashboard',
  },
  //CAMO
  {
    component: CNavGroup,
    name: 'CAMO',
    icon: <CIcon icon={cilCalendar} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Add/Update Defects',
        /*to: '/camo/addUpdateDefects',*/
        to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
        target: '_blank',
        perm: 'aud',
      },
      {
        component: CNavGroup,
        name: 'Asset Management',
        items: [
          {
            component: CNavItem,
            name: 'Engine',
            /* to: '/camo/am/engineManagement',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'aueng',
          },
          {
            component: CNavItem,
            name: 'APU',
            /*  to: '/camo/am/apuManagement',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'auapu',
          },
          {
            component: CNavItem,
            name: 'Landing Gear',
            /*to: '/camo/am/landingGearManagement',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'aulg',
          },
          {
            component: CNavItem,
            name: 'Aircraft Configuration',
            /*to: '/camo/am/aircraftManagement',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'auac',
          },


        ],
      },
      {
        component: CNavGroup,
        name: 'Maintenance Planning',
        items: [
          {
            component: CNavItem,
            name: 'AMP Management',
            /*to: '/camo/mp/ampManagment',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'aump',
          },
          {
            component: CNavItem,
            name: 'ELLP Management',
            /*to: '/camo/mp/enginellp',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'auellp',
          },

          {
            component: CNavItem,
            name: 'Compliance Status',
            /*to: '/camo/mp/complianceStatus',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'mp',
          },
          {
            component: CNavItem,
            name: 'Maintenance Forecast',
            /*to: '/camo/mp/maintenanceForecast',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'mp',
          },
          {
            component: CNavItem,
            name: 'Package Generation',
            /*to: '/camo/mp/packageGeneration',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'pg',
          },


        ],

      },

      {
        component: CNavGroup,
        name: 'Reports',
        items: [
          {
            component: CNavItem,
            name: 'Aircraft Defects',
            /*to: '/camo/reports/aircraftDefects',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'ds',
          },
          {
            component: CNavItem,
            name: 'Fleet',
            /*to: '/camo/reports/fleet',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'fleet',
          },
          {
            component: CNavItem,
            name: 'Search Engine LLP(s)',
            /*to: '/camo/reports/seacrhEngineLLPs',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'sellp',
          },

          {
            component: CNavItem,
            name: 'Package List',
            /*to: '/camo/reports/packageList',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'pg',
          },



        ],
      },

    ],

  },
  //MRO
  {
    component: CNavGroup,
    name: 'MRO',
    icon: <CIcon icon={cilCog} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Task Assignment',
        /*   to: '/mro/taskAssignment',*/
        to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
        target: '_blank',
        perm: 'mpta',
      },
      {
        component: CNavGroup,
        name: 'Planning',
        items: [
          {
            component: CNavItem,
            name: 'Task Evaluation',
            /*to: '/mro/planning/taskEvaluation',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'mpte',
          },
          {
            component: CNavItem,
            name: 'Evaluated Tasks',
            /*to: '/mro/planning/evaluatedTasks',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'mpet',
          },

        ],
      },
      {
        component: CNavGroup,
        name: 'Reports',
        items: [
          {
            component: CNavItem,
            name: 'Submitted Package(s)',
            /*to: '/mro/reports/submittedPackages',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'mpsp',
          },
          {
            component: CNavItem,
            name: 'Search Task(s)',
            /*to: '/mro/reports/searchTasks',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'mpst',
          },

        ],
      },


    ],
  },
  //Duplicate Audit
  //{
  //  component: CNavGroup,
  //  name: 'Compliance & Audit',
  //  icon: <CIcon icon={cilCheckAlt} customClassName="nav-icon" />,
  //  items: [
  //    {
  //      component: CNavGroup,
  //      name: 'Schedule Audit',
  //      items: [
  //        {
  //          component: CNavItem,
  //          name: 'Maintenance',
  //          to: 'compaliance&Audit/scheduleReports/maintenance',
  //          perm: 'for',
  //        },
  //        {
  //          component: CNavItem,
  //          name: 'Operator',
  //          to: 'compaliance&Audit/scheduleReports/operator',
  //          perm: 'for',
  //        },

  //      ],
  //      },


  //  ],
  //},

  //Procurement
  {
    component: CNavGroup,
    name: 'Procurement',
    icon: <CIcon icon={cilCart} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Generate Demand',
        // to: '/procurement/generateDemand',
        to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
        target: '_blank',

        perm: 'pgd',
      },
      {
        component: CNavItem,
        name: 'Generate RFQ',
        /*to: '/procurement/GenerateRFQ',*/
         to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
        perm: 'pdl',
      },
      {
        component: CNavItem,
        name: 'Demand List',
        to: '/procurement/DemandList',
        /*to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',*/
        perm: 'pdl',
      },
      {
        component: CNavItem,
        name: 'Quote Management',
        /*to: '/procurement/quoteManagement',*/
        to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
        target: '_blank',
        perm: 'pauq',
      },
      {
        component: CNavItem,
        name: 'Vendor Management',
        /*to: '/procurement/vendorManagement',*/
        to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
        target: '_blank',
        perm: 'pauv',
      },
      {
        component: CNavItem,
        name: 'Quote Recommendation',
        /*to: '/procurement/quoteRecommendation',*/
        to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
        target: '_blank',
        perm: 'pqr',
      },
      {
        component: CNavItem,
        name: 'Technical Approval',
        /*to: '/procurement/technicalApproval',*/
        to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
        target: '_blank',
        perm: 'qta',
      },
      {
        component: CNavItem,
        name: 'Procurement Review',
        /*to: '/procurement/procurementReview',*/
        to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
        target: '_blank',
        perm: 'qpr',
      },
      {
        component: CNavItem,
        name: 'Financial Approval(s)',
        /*to: '/procurement/financialApproval',*/
        to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
        target: '_blank',
        perm: 'qfa',
      },

      {
        component: CNavItem,
        name: 'Generate PO',
        /*to: '/procurement/generatePO',*/
        to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
        target: '_blank',
        perm: 'pgpo',
      },

      {
        component: CNavGroup,
        name: 'Reports',
        perm: 'prpt',
        items: [
          {
            component: CNavItem,
            name: 'Search Demand(s)',
            to: '/procurement/reports/searchDemand',
            perm: 'prsd',
          },
          {
            component: CNavItem,
            name: 'Search Quote(s)',
            to: '/procurement/reports/searchQuote',
            perm: 'prsq',
          },
          {
            component: CNavItem,
            name: 'Search Quote Approval(s)',
            to: '/procurement/reports/searchQuoteapproval',
            perm: 'prsqa',
          },
          {
            component: CNavItem,
            name: 'Search PO(s)',
            to: '/procurement/reports/searchPOitem',
            perm: 'prspo',
          },

        ],
      },


    ],
  },
  //Inventory
  {
    component: CNavGroup,
    name: 'Inventory',
    icon: <CIcon icon={cilClipboard} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Master Part Management',
        /* to: '/inventory/masterPartManagement',*/
        to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
        target: '_blank',
        perm: 'invmpm',
      },
      {
        component: CNavItem,
        name: 'Receive Part(s)',
        /*to: '/inventory/receiveParts',*/
        to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
        target: '_blank',
        perm: 'invrec',
      },
      {
        component: CNavItem,
        name: 'Issue Part(s)',
        /*to: '/inventory/issueParts',*/
        to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
        target: '_blank',
        perm: 'inviss',
      },
      {
        component: CNavItem,
        name: 'Stock Inventory',
        /*to: '/inventory/stockInventory',*/
        to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
        target: '_blank',
        perm: 'invsi',
      },

      {
        component: CNavGroup,
        name: 'Reports',
        perm: 'invrpt',
        items: [
          {
            component: CNavItem,
            name: 'Receiving History',
            /*to: '/inventory/reports/receivingHistory',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'invrch',
          },
          {
            component: CNavItem,
            name: 'Issuance History',
            /*to: '/inventory/reports/issuanceHistory',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'invish',
          },
          {
            component: CNavItem,
            name: 'Low Inventory',
            /*to: '/inventory/reports/lowInventory',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'invli',
          },
          {
            component: CNavItem,
            name: 'Shelf Life Expiry',
            /*to: '/inventory/reports/shelfLifeExpiry',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'invsle',
          },

        ],
      },


    ],
  },
  {
    component: CNavTitle,
    name: 'QA & SAFETY',
    perm: 'dashboard',
  },
  //Audit
  {
    component: CNavGroup,
    name: 'Audit',
    icon: <CIcon icon={cilCheck} customClassName="nav-icon" />,
    perm: 'qa',
    items: [
      {
        component: CNavItem,
        name: 'Audit Schedule',
        /*  to: '/audit/auditschedule',*/
        to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
        target: '_blank',
        perm: 'qaas',
      },
      {
        component: CNavItem,
        name: 'Audit Checklist',
        /*to: '/audit/auditChecklist',*/
        to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
        target: '_blank',
        perm: 'qaac',
      },


    ],
  },
  //SMS
  {
    component: CNavGroup,
    name: 'SMS',
    icon: <CIcon icon={cilWarning} customClassName="nav-icon" />,
    items: [
      {
        component: CNavGroup,
        name: 'Reports',
        items: [
          {
            component: CNavItem,
            name: 'Hazard Reports',
            /*to: '/sms/reports/hazardReports',*/
            to: '//samsv1.visionairintl.com/Login.aspx?ReturnUrl=%2f',
            target: '_blank',
            perm: 'smshr',
          },

        ],
      },


    ],
  },

  //{
  //  component: CNavTitle,
  //  name: 'Theme',
  //},
  //{
  //  component: CNavItem,
  //  name: 'Colors',
  //  to: '/theme/colors',
  //  icon: <CIcon icon={cilDrop} customClassName="nav-icon" />,
  //},
  //{
  //  component: CNavItem,
  //  name: 'Typography',
  //  to: '/theme/typography',
  //  icon: <CIcon icon={cilPencil} customClassName="nav-icon" />,
  //},
  //{
  //  component: CNavTitle,
  //  name: 'Components',
  //},
  //{
  //  component: CNavGroup,
  //  name: 'Base',
  //  to: '/base',
  //  icon: <CIcon icon={cilPuzzle} customClassName="nav-icon" />,
  //  items: [
  //    {
  //      component: CNavItem,
  //      name: 'Accordion',
  //      to: '/base/accordion',
  //    },
  //    {
  //      component: CNavItem,
  //      name: 'Breadcrumb',
  //      to: '/base/breadcrumbs',
  //    },
  //    {
  //      component: CNavItem,
  //      name: 'Cards',
  //      to: '/base/cards',
  //    },
  //    {
  //      component: CNavItem,
  //      name: 'Carousel',
  //      to: '/base/carousels',
  //    },
  //    {
  //      component: CNavItem,
  //      name: 'Collapse',
  //      to: '/base/collapses',
  //    },
  //    {
  //      component: CNavItem,
  //      name: 'List group',
  //      to: '/base/list-groups',
  //    },
  //    {
  //      component: CNavItem,
  //      name: 'Navs & Tabs',
  //      to: '/base/navs',
  //    },
  //    {
  //      component: CNavItem,
  //      name: 'Pagination',
  //      to: '/base/paginations',
  //    },
  //    {
  //      component: CNavItem,
  //      name: 'Placeholders',
  //      to: '/base/placeholders',
  //    },
  //    {
  //      component: CNavItem,
  //      name: 'Popovers',
  //      to: '/base/popovers',
  //    },
  //    {
  //      component: CNavItem,
  //      name: 'Progress',
  //      to: '/base/progress',
  //    },
  //    {
  //      component: CNavItem,
  //      name: 'Spinners',
  //      to: '/base/spinners',
  //    },
  //    {
  //      component: CNavItem,
  //      name: 'Tables',
  //      to: '/base/tables',
  //    },
  //    {
  //      component: CNavItem,
  //      name: 'Tooltips',
  //      to: '/base/tooltips',
  //    },
  //  ],
  //},
  //{
  //  component: CNavGroup,
  //  name: 'Buttons',
  //  to: '/buttons',
  //  icon: <CIcon icon={cilCursor} customClassName="nav-icon" />,
  //  items: [
  //    {
  //      component: CNavItem,
  //      name: 'Buttons',
  //      to: '/buttons/buttons',
  //    },
  //    {
  //      component: CNavItem,
  //      name: 'Buttons groups',
  //      to: '/buttons/button-groups',
  //    },
  //    {
  //      component: CNavItem,
  //      name: 'Dropdowns',
  //      to: '/buttons/dropdowns',
  //    },
  //  ],
  //},
  //{
  //  component: CNavGroup,
  //  name: 'Forms',
  //  icon: <CIcon icon={cilNotes} customClassName="nav-icon" />,
  //  items: [
  //    {
  //      component: CNavItem,
  //      name: 'Form Control',
  //      to: '/forms/form-control',
  //    },
  //    {
  //      component: CNavItem,
  //      name: 'Select',
  //      to: '/forms/select',
  //    },
  //    {
  //      component: CNavItem,
  //      name: 'Checks & Radios',
  //      to: '/forms/checks-radios',
  //    },
  //    {
  //      component: CNavItem,
  //      name: 'Range',
  //      to: '/forms/range',
  //    },
  //    {
  //      component: CNavItem,
  //      name: 'Input Group',
  //      to: '/forms/input-group',
  //    },
  //    {
  //      component: CNavItem,
  //      name: 'Floating Labels',
  //      to: '/forms/floating-labels',
  //    },
  //    {
  //      component: CNavItem,
  //      name: 'Layout',
  //      to: '/forms/layout',
  //    },
  //    {
  //      component: CNavItem,
  //      name: 'Validation',
  //      to: '/forms/validation',
  //    },
  //  ],
  //},
  //{
  //  component: CNavItem,
  //  name: 'Charts',
  //  to: '/charts',
  //  icon: <CIcon icon={cilChartPie} customClassName="nav-icon" />,
  //},
  //{
  //  component: CNavGroup,
  //  name: 'Icons',
  //  icon: <CIcon icon={cilStar} customClassName="nav-icon" />,
  //  items: [
  //    {
  //      component: CNavItem,
  //      name: 'CoreUI Free',
  //      to: '/icons/coreui-icons',
  //      badge: {
  //        color: 'success',
  //        text: 'NEW',
  //      },
  //    },
  //    {
  //      component: CNavItem,
  //      name: 'CoreUI Flags',
  //      to: '/icons/flags',
  //    },
  //    {
  //      component: CNavItem,
  //      name: 'CoreUI Brands',
  //      to: '/icons/brands',
  //    },
  //  ],
  //},
  //{
  //  component: CNavGroup,
  //  name: 'Notifications',
  //  icon: <CIcon icon={cilBell} customClassName="nav-icon" />,
  //  items: [
  //    {
  //      component: CNavItem,
  //      name: 'Alerts',
  //      to: '/notifications/alerts',
  //    },
  //    {
  //      component: CNavItem,
  //      name: 'Badges',
  //      to: '/notifications/badges',
  //    },
  //    {
  //      component: CNavItem,
  //      name: 'Modal',
  //      to: '/notifications/modals',
  //    },
  //    {
  //      component: CNavItem,
  //      name: 'Toasts',
  //      to: '/notifications/toasts',
  //    },
  //  ],
  //},
  //{
  //  component: CNavItem,
  //  name: 'Widgets',
  //  to: '/widgets',
  //  icon: <CIcon icon={cilCalculator} customClassName="nav-icon" />,
  //  badge: {
  //    color: 'info',
  //    text: 'NEW',
  //  },
  //},
  //{
  //  component: CNavTitle,
  //  name: 'Extras',
  //},
  //{
  //  component: CNavGroup,
  //  name: 'Pages',
  //  icon: <CIcon icon={cilStar} customClassName="nav-icon" />,
  //  items: [
  //    {
  //      component: CNavItem,
  //      name: 'Login',
  //      to: '/login',
  //    },
  //    {
  //      component: CNavItem,
  //      name: 'Register',
  //      to: '/register',
  //    },
  //    {
  //      component: CNavItem,
  //      name: 'Error 404',
  //      to: '/404',
  //    },
  //    {
  //      component: CNavItem,
  //      name: 'Error 500',
  //      to: '/500',
  //    },
  //  ],
  //},

];

export default _nav

//const _nav = [
//  {
//    component: CNavItem,
//    name: 'Dashboard',
//    to: '/dashboard',
//    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
//    badge: {
//      color: 'info',
//      text: 'NEW',
//    },
//  },
//  {
//    component: CNavTitle,
//    name: 'Theme',
//  },
//  {
//    component: CNavItem,
//    name: 'Colors',
//    to: '/theme/colors',
//    icon: <CIcon icon={cilDrop} customClassName="nav-icon" />,
//  },
//  {
//    component: CNavItem,
//    name: 'Typography',
//    to: '/theme/typography',
//    icon: <CIcon icon={cilPencil} customClassName="nav-icon" />,
//  },
//  {
//    component: CNavTitle,
//    name: 'Components',
//  },
//  {
//    component: CNavGroup,
//    name: 'Base',
//    to: '/base',
//    icon: <CIcon icon={cilPuzzle} customClassName="nav-icon" />,
//    items: [
//      {
//        component: CNavItem,
//        name: 'Accordion',
//        to: '/base/accordion',
//      },
//      {
//        component: CNavItem,
//        name: 'Breadcrumb',
//        to: '/base/breadcrumbs',
//      },
//      {
//        component: CNavItem,
//        name: 'Cards',
//        to: '/base/cards',
//      },
//      {
//        component: CNavItem,
//        name: 'Carousel',
//        to: '/base/carousels',
//      },
//      {
//        component: CNavItem,
//        name: 'Collapse',
//        to: '/base/collapses',
//      },
//      {
//        component: CNavItem,
//        name: 'List group',
//        to: '/base/list-groups',
//      },
//      {
//        component: CNavItem,
//        name: 'Navs & Tabs',
//        to: '/base/navs',
//      },
//      {
//        component: CNavItem,
//        name: 'Pagination',
//        to: '/base/paginations',
//      },
//      {
//        component: CNavItem,
//        name: 'Placeholders',
//        to: '/base/placeholders',
//      },
//      {
//        component: CNavItem,
//        name: 'Popovers',
//        to: '/base/popovers',
//      },
//      {
//        component: CNavItem,
//        name: 'Progress',
//        to: '/base/progress',
//      },
//      {
//        component: CNavItem,
//        name: 'Spinners',
//        to: '/base/spinners',
//      },
//      {
//        component: CNavItem,
//        name: 'Tables',
//        to: '/base/tables',
//      },
//      {
//        component: CNavItem,
//        name: 'Tooltips',
//        to: '/base/tooltips',
//      },
//    ],
//  },
//  {
//    component: CNavGroup,
//    name: 'Buttons',
//    to: '/buttons',
//    icon: <CIcon icon={cilCursor} customClassName="nav-icon" />,
//    items: [
//      {
//        component: CNavItem,
//        name: 'Buttons',
//        to: '/buttons/buttons',
//      },
//      {
//        component: CNavItem,
//        name: 'Buttons groups',
//        to: '/buttons/button-groups',
//      },
//      {
//        component: CNavItem,
//        name: 'Dropdowns',
//        to: '/buttons/dropdowns',
//      },
//    ],
//  },
//  {
//    component: CNavGroup,
//    name: 'Forms',
//    icon: <CIcon icon={cilNotes} customClassName="nav-icon" />,
//    items: [
//      {
//        component: CNavItem,
//        name: 'Form Control',
//        to: '/forms/form-control',
//      },
//      {
//        component: CNavItem,
//        name: 'Select',
//        to: '/forms/select',
//      },
//      {
//        component: CNavItem,
//        name: 'Checks & Radios',
//        to: '/forms/checks-radios',
//      },
//      {
//        component: CNavItem,
//        name: 'Range',
//        to: '/forms/range',
//      },
//      {
//        component: CNavItem,
//        name: 'Input Group',
//        to: '/forms/input-group',
//      },
//      {
//        component: CNavItem,
//        name: 'Floating Labels',
//        to: '/forms/floating-labels',
//      },
//      {
//        component: CNavItem,
//        name: 'Layout',
//        to: '/forms/layout',
//      },
//      {
//        component: CNavItem,
//        name: 'Validation',
//        to: '/forms/validation',
//      },
//    ],
//  },
//  {
//    component: CNavItem,
//    name: 'Charts',
//    to: '/charts',
//    icon: <CIcon icon={cilChartPie} customClassName="nav-icon" />,
//  },
//  {
//    component: CNavGroup,
//    name: 'Icons',
//    icon: <CIcon icon={cilStar} customClassName="nav-icon" />,
//    items: [
//      {
//        component: CNavItem,
//        name: 'CoreUI Free',
//        to: '/icons/coreui-icons',
//        badge: {
//          color: 'success',
//          text: 'NEW',
//        },
//      },
//      {
//        component: CNavItem,
//        name: 'CoreUI Flags',
//        to: '/icons/flags',
//      },
//      {
//        component: CNavItem,
//        name: 'CoreUI Brands',
//        to: '/icons/brands',
//      },
//    ],
//  },
//  {
//    component: CNavGroup,
//    name: 'Notifications',
//    icon: <CIcon icon={cilBell} customClassName="nav-icon" />,
//    items: [
//      {
//        component: CNavItem,
//        name: 'Alerts',
//        to: '/notifications/alerts',
//      },
//      {
//        component: CNavItem,
//        name: 'Badges',
//        to: '/notifications/badges',
//      },
//      {
//        component: CNavItem,
//        name: 'Modal',
//        to: '/notifications/modals',
//      },
//      {
//        component: CNavItem,
//        name: 'Toasts',
//        to: '/notifications/toasts',
//      },
//    ],
//  },
//  {
//    component: CNavItem,
//    name: 'Widgets',
//    to: '/widgets',
//    icon: <CIcon icon={cilCalculator} customClassName="nav-icon" />,
//    badge: {
//      color: 'info',
//      text: 'NEW',
//    },
//  },
//  {
//    component: CNavTitle,
//    name: 'Extras',
//  },
//  {
//    component: CNavGroup,
//    name: 'Pages',
//    icon: <CIcon icon={cilStar} customClassName="nav-icon" />,
//    items: [
//      {
//        component: CNavItem,
//        name: 'Login',
//        to: '/login',
//      },
//      {
//        component: CNavItem,
//        name: 'Register',
//        to: '/register',
//      },
//      {
//        component: CNavItem,
//        name: 'Error 404',
//        to: '/404',
//      },
//      {
//        component: CNavItem,
//        name: 'Error 500',
//        to: '/500',
//      },
//    ],
//  },
//  {
//    component: CNavItem,
//    name: 'Docs',
//    href: 'https://coreui.io/react/docs/templates/installation/',
//    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
//  },
//]

//export default _nav
